import styled from 'styled-components';

import { Feedback } from '@shared/constants/feedback';
import { FeedbackUser } from '@components/atoms';

type FeedbackCardProps = Feedback & {
  isCenter?: boolean;
  fontSize?: number;
  lineHeight?: number;
};

function FeedbackCard({
  descriptionMain,
  descriptionSlave,
  isCenter,
  lineHeight,
  fontSize,
  ...rest
}: FeedbackCardProps) {
  return (
    <Wrapper>
      <TextWrapper>
        <StyledSpan
          $lineHeight={lineHeight}
          $fontSize={fontSize}
          $isCenter={isCenter}
        >
          {descriptionMain}
        </StyledSpan>

        <StyledSpan
          $lineHeight={lineHeight}
          $fontSize={fontSize}
          $isCenter={isCenter}
        >
          {descriptionSlave}
        </StyledSpan>
      </TextWrapper>

      <FeedbackUser lineHeight={lineHeight} fontSize={fontSize} {...rest} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 20px;
  width: 100%;
  height: 100%;
  padding: 32px;
  margin-bottom: 20px;
  border-radius: 16px;

  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
`;

const StyledSpan = styled.span<{
  $fontSize?: number;
  $lineHeight?: number;
  $isCenter?: boolean;
}>`
  display: -webkit-box;

  width: 100%;
  font-size: ${({ $fontSize }) => $fontSize || 20}px;
  line-height: ${({ $lineHeight }) => $lineHeight || 26}px;

  overflow: ${({ $isCenter }) => !$isCenter && 'hidden'};
  -webkit-line-clamp: ${({ $isCenter }) => !$isCenter && 4};
  text-overflow: ${({ $isCenter }) => !$isCenter && 'ellipsis'};
  -webkit-box-orient: ${({ $isCenter }) => !$isCenter && 'vertical'};

  color: ${({ theme }) => theme.colors.textPrimary};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default FeedbackCard;
